import { priceFormat } from 'util/prices'
import { useStore } from 'store'
import { useEffect , useState } from 'react'
import { hideLoader, showLoader } from 'store/actions/commons'
import { BASE_PATH_API } from 'constants/env'
import { decodeStorage } from 'functions/storageBase64'
import PaginationList from 'newComponents/pagination'
import styles from './styles.module.sass'

const respService = {
    data: [
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '19/09/2024',
            'horaMovimiento': '18:48:47',
            'codigoTransaccion': '13',
            'numeroTransaccion': '234690',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000000000',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '000778',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '26/08/2024',
            'horaMovimiento': '17:45:13',
            'codigoTransaccion': '01',
            'numeroTransaccion': '1',
            'unidad': '2001',
            'terminal': '2001',
            'operador': 'EPerez',
            'importe': '000000009700',
            'respuestaPOS': 'Certificado Inactivo',
            'numeroAutorizacion': '--',
            'tipoEntrada': 'Digitado',
            'origen': 'CAU'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '22/08/2024',
            'horaMovimiento': '00:14:12',
            'codigoTransaccion': '31',
            'numeroTransaccion': '482',
            'unidad': 'Multiple',
            'terminal': '00',
            'operador': 'ECesar',
            'importe': '000000000000',
            'respuestaPOS': 'Estatus Cambio a Inactivo',
            'numeroAutorizacion': '045514',
            'tipoEntrada': 'Digitado',
            'origen': 'CAU'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '22/08/2024',
            'horaMovimiento': '00:09:54',
            'codigoTransaccion': '07',
            'numeroTransaccion': '482',
            'unidad': 'Multiple',
            'terminal': '1111',
            'operador': 'ECesar',
            'importe': '000000009200',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '007642',
            'tipoEntrada': 'Digitado',
            'origen': 'CAU'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '21/08/2024',
            'horaMovimiento': '23:59:53',
            'codigoTransaccion': '31',
            'numeroTransaccion': '482',
            'unidad': 'Multiple',
            'terminal': '00',
            'operador': 'ECesar',
            'importe': '000000000000',
            'respuestaPOS': 'Estatus Cambio a Activo',
            'numeroAutorizacion': '015870',
            'tipoEntrada': 'Digitado',
            'origen': 'CAU'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '21/08/2024',
            'horaMovimiento': '07:49:24',
            'codigoTransaccion': '22',
            'numeroTransaccion': '8231',
            'unidad': 'Multiple',
            'terminal': '00',
            'operador': 'NCarrasco',
            'importe': '000000000000',
            'respuestaPOS': 'Estatus Cambio a Inactivo',
            'numeroAutorizacion': '087199',
            'tipoEntrada': 'Digitado',
            'origen': 'CAU'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '20/08/2024',
            'horaMovimiento': '13:01:44',
            'codigoTransaccion': '03',
            'numeroTransaccion': '237191',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000009200',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '043094',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '13/08/2024',
            'horaMovimiento': '11:39:56',
            'codigoTransaccion': '09',
            'numeroTransaccion': '251516',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000009200',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '026515',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '12/08/2024',
            'horaMovimiento': '13:56:12',
            'codigoTransaccion': '12',
            'numeroTransaccion': '243575',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000009200',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '079242',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '09/07/2024',
            'horaMovimiento': '10:40:10',
            'codigoTransaccion': '06',
            'numeroTransaccion': '207921',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000018900',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '051053',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '03/07/2024',
            'horaMovimiento': '18:56:42',
            'codigoTransaccion': '04',
            'numeroTransaccion': '260444',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000018900',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '073054',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '02/07/2024',
            'horaMovimiento': '11:42:18',
            'codigoTransaccion': '10',
            'numeroTransaccion': '245516',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000018900',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '044669',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '02/07/2024',
            'horaMovimiento': '11:40:50',
            'codigoTransaccion': '07',
            'numeroTransaccion': '245492',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000018900',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '077857',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '01/07/2024',
            'horaMovimiento': '11:38:56',
            'codigoTransaccion': '13',
            'numeroTransaccion': '233177',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000018900',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '081494',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '27/06/2024',
            'horaMovimiento': '11:01:44',
            'codigoTransaccion': '01',
            'numeroTransaccion': '286403',
            'unidad': '6570',
            'terminal': '0202',
            'operador': '--',
            'importe': '000000018900',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '032651',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        },
        {
            'numeroFolio': '1508********4212',
            'fechaMovimiento': '27/06/2024',
            'horaMovimiento': '10:24:51',
            'codigoTransaccion': '13',
            'numeroTransaccion': '286105',
            'unidad': '6570',
            'terminal': '0022',
            'operador': '--',
            'importe': '000000000000',
            'respuestaPOS': 'Aprobada',
            'numeroAutorizacion': '055480',
            'tipoEntrada': 'Digitado',
            'origen': 'Linea'
        }
    ],
    pagination: {
        total: 113
    }
}


const adapterHistory = (response) => {

    const meses = {
        '01': 'Enero',
        '02': 'Febrero',
        '03': 'Marzo',
        '04': 'Abril',
        '05': 'Mayo',
        '06': 'Junio',
        '07': 'Julio',
        '08': 'Agosto',
        '09': 'Septiembre',
        '10': 'Octubre',
        '11': 'Noviembre',
        '12': 'Diciembre'
    };

    const transIcon = [
        {key: '01', value: 'Obsequio Recibido'},
        {key: '07', value: 'Compra'},
        {key: '13', value: 'Consulta Saldo'},
        {key: '04', value: 'Devolución'},
        {key: '10', value: 'Devolución'},
        {key: '31', value: 'Cambio Estatus'},
        {key: '22', value: 'Traspaso'},
        {key: '03', value: 'Reverso Abono'},
        {key: '09', value: 'Reverso Compra'},
        {key: '12', value: 'Reverso Devolución Compra'},
        {key: '06', value: 'Reverso Devolución Abono'}
    ];

    const resultado = response.reduce((acumulador, objeto) => {
        const fecha = objeto.fechaMovimiento.split('/');
        const año = fecha[2];
        const mes = fecha[1];
        const periodo = `${meses[mes]} ${año}`;
        const indexIcon = transIcon.findIndex(inIcon => inIcon?.key === objeto?.codigoTransaccion)
      
        const movimiento = {
          typeIcon: Number(indexIcon),
          type: transIcon?.[indexIcon]?.value,
          monto: parseFloat(objeto?.importe) / 100,
          text: String(`No. Autorización: ${objeto?.numeroAutorizacion}`),
          date: `${fecha[0]} ${meses[mes].substring(0, 3).toUpperCase()} ${objeto?.horaMovimiento}`
        };
      
        if (!acumulador[periodo]) {
          acumulador[periodo] = {
            periodo,
            movements: [movimiento]
          };
        } else {
          acumulador[periodo].movements.push(movimiento);
        }
      
        return acumulador;
    }, {});
      
    const resultadoFinal = Object.values(resultado)
    return resultadoFinal
}

const EdosCuentaMonedero = (props) => {
    const {
        setMonedero,
        setEdosCuenta,
        hashToken,
        saldo_actual
    } = props

    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    const access_token = decodeStorage('access_token')
    const [ historial, setHistorial ] = useState(null) // respService
    const [ historyResp, setHistoryResp ] = useState(null)
    const [ selectPage, setSelectPage ] = useState(1)
    const [ actualPage, setActualPage ] = useState(1)
    const [ totalPage, setTotalPage ] = useState(null)
    const resPerPage = 50

    const returnBack = () => {
        setMonedero(null)
        setEdosCuenta(false)
    }

    const getWalletHistory = async ({eventID, page = 1, sizePage = 200 }) => {
        dispatch(showLoader());
        const payload = {
            servicio: 'consultaHistorico',
            tipoCompania: '2',    
            solicitadoPor: '13',
            shanum: eventID,
            page,
            sizePage
        }
        
        try {
            const header = {
                method: 'POST',
                headers: { 
                    'Content-Type':'application/json',
                    'Authorization': `Bearer ${access_token}`
                },
                body: JSON.stringify(payload)
            }
            const response = await fetch(`${BASE_PATH_API}/app/v1/teleproceso`, header);

            const data = await response.json();
            setHistorial(data)
        } catch (error) {
            dispatch(hideLoader());
            console.error('Error fetching getEventTable data:', error);
        }
    }

    useEffect(()=>{
        if(selectPage){
            console.log('selectPage: ',selectPage)
            setActualPage(selectPage)
            if(hashToken){
                getWalletHistory({
                    eventID: hashToken,
                    page: selectPage,
                    sizePage: resPerPage
                })
            }
        }
    },[ hashToken, selectPage ])
    

    useEffect(()=>{
        if(historial){
            // console.log('historial: ',historial)
            if(historial){
                dispatch(hideLoader())
                // const historialUltimo = historial?.data
                const historialUltimo = historial?.data.filter(movimiento => 
                    movimiento?.codigoTransaccion !== '13' && 
                    movimiento?.codigoTransaccion !== '31' &&
                    movimiento?.codigoTransaccion !== '22' && 
                    movimiento?.codigoTransaccion !== '03' && 
                    movimiento?.codigoTransaccion !== '09' && 
                    movimiento?.codigoTransaccion !== '12' && 
                    movimiento?.codigoTransaccion !== '06' 
                )

                const response = adapterHistory(historialUltimo)
                setHistoryResp(response)
                setActualPage(1)
                // setTotalPage(historial?.pagination?.total)
            }
        }
    },[historial])

    const iconArray = [
        'icoAbono', // verde
        'icoCompra', // gris
        'icoConsulta', // blanco

        'icoCompra', 
        'icoAbono', 
        'icoConsulta',
        'icoConsulta', 
        'icoCompra', 
        'icoAbono',
        'icoAbono', 
        'icoCompra'
    ]
    return(
        <>
            <div className={styles?.sectionHistory}>
                <div onClick={returnBack} className={styles?.returnBack} aria-hidden>Regresar</div>
                <h1>Historial de monedero</h1>

                <div className={styles?.contCardsAmounts}>
                    <p>Saldo actual disponible:</p>
                    <span>{saldo_actual}</span>
                </div>

                <div className={styles?.contHistory} >

                    {historyResp
                        ?
                            <>
                                {historyResp.map((period, index) => 
                                    <div className={styles?.contHistorySection} key={index}>
                                        <h2>{period?.periodo}</h2>
                                            <div>
                                                {period?.movements?.length >= 1
                                                    ?
                                                        period?.movements.map((movemen, ind) =>
                                                            <div className={`${styles?.cardHistory} ${movemen?.typeIcon === 0 ? styles?.abono : null}`} key={ind}>
                                                                <div className={styles?.[iconArray[movemen?.typeIcon]]} />
                                                                <div className={styles?.type}>{movemen?.type}</div>
                                                                <div className={styles?.mont}>{`$${priceFormat(movemen?.monto)}`}</div>
                                                                <div className={styles?.text}>{movemen?.text}</div>
                                                                <div className={styles?.date}>{movemen?.date}</div>
                                                            </div>
                                                        )
                                                    : 
                                                        <div>Actualmente la cuenta no cuenta con movimientos</div>
                                                }
                                            </div>
                                        </div>
                                )}
                                {totalPage
                                    ?
                                        <PaginationList
                                            setPage={setSelectPage}
                                            selectedPage={actualPage || 1}
                                            cantResults={totalPage}
                                            cantResultPerPage={resPerPage}
                                        />
                                    : null
                                }
                            </>
                        : null
                    }
                   
                </div>
            </div>
        </>
    )
}

export default EdosCuentaMonedero